import type { FilteringService } from '.';

export function Sort(this: FilteringService): string {
  switch (this.sort()) {
    case 'newest':
      return 'date:desc';
    case 'price-high':
      return 'price:desc,date:desc';
    case 'price-low':
      return 'price:asc,date:desc';
    default:
      return 'openTodayStart:asc,openTomorrowStart:asc,date:desc';
  }
}

export function SortUrlToFilter(this: FilteringService, sort: string): string {
  switch (sort) {
    case 'date:desc':
      return 'newest';
    case 'price:asc,date:desc':
      return 'price-low';
    case 'price:desc,date:desc':
      return 'price-high';
    default:
      return 'open';
  }
}
